import React, { Component }          from 'react';

import icClose                       from '../../../img/ic_close.svg';

import "./Dialog.scss";

class DeleteDialog extends Component {

  constructor(props) {
    super(props);
  }

  onFieldChange(name, event) {
    this.setState({[name]: event.target.value});
  }

  onMultiSelectChange(name, data) {
    this.setState({[name]: data});
  }

  renderTimeZones() {
    return TIMEZONES.map(timezone => {
      return <option value={timezone.value}>{timezone.text}</option>
    })
  }

  render() {
    return (
      <div className={`edit-dialog ${this.props.show ? 'show' : ''}`}>
        <div className="content">
          <div className="dialog-title small">{this.props.text}</div>
          <div className="bottom-buttons space-between">
            <div onClick={this.props.onDeny.bind(this)} className="action-button">NO</div>
            <div onClick={this.props.onConfirm.bind(this)} className="action-button">YES</div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeleteDialog;